module.exports = __webpack_public_path__ + "static/media/tap_06_img01.155b79aa.png";